// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2sLsB","ThumbZoom":"ChapterPlayer_ThumbZoom__3E4jo"};